

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { LocationsSetup } from "../../components/LocationsSetup/LocationsSetup";


export const LocationsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Locations Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Locations", navigateTo: "/company/locations/list" },
        { text: "Create Locations", navigateTo: "/company/locations/setup" }
      ]}
      mainContents={<LocationsSetup />}
    />
  );
};
